import { schemeLists } from './../../plugins/js/data';

$(() => {
    const ID = getUrlParams('id');
    if (!ID) alert("缺少案例id");
    const detail = schemeLists.find(item => item.id === ID);
    if (!detail) alert("错误的id");
    $(".location-msg .scheme-name").html('解决方案>' + (detail.btnText || detail.title));
    $(".detail-head h1").html(detail.title);
    $(".detail-head p").html(detail.descText);

    let imgs = ``;
    detail.detailImgs && detail.detailImgs.forEach(item=>{
        imgs += `<div class="swiper-slide"><img src="./../img/detail/${ item }" alt=""></div>`
    });
    let swipperHtml =
        `
            <div class="swiper-container">
                <div class="swiper-wrapper"> 
                ${ imgs }
                </div>
                <div class="swiper-pagination"></div>
            </div>
        `;
    $(".detail-head").append($(swipperHtml));

    let dom = detail.scene && detail.scene.reduce((str='', item)=>{
        return str + `<div class="item">${ item }</div>`;
    }, "");
    $(".scene-container").html(dom);

    if(detail.feature){
        let dom = detail.feature && detail.feature.reduce((str='', item, index)=>{
            return str + `<p><span>${index + 1}.</span><span>${ item }</span></p>`;
        }, "");
        $(".scheme-feature").html(dom);
    }else{
        $(".scheme-feature-title").remove();
    }
    if(detail.fun){
        let dom = detail.fun && detail.fun.reduce((str='', item, index)=>{
            return str + `<p><span>${index + 1}.</span><span>${ item }</span></p>`;
        }, "");
        $(".scheme-fun").html(dom);
    }else{
        $(".scheme-fun-title").remove();
    }

    new Swiper('.swiper-container', {
        loop: true, // 循环模式选项
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
        }
    });
});

function getUrlParams(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
}
